import React, { useEffect, useRef, useState } from "react";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../../components/recharts/functions";
import loader from "../../../../components/recharts/loader.gif";
import { ReMixChart } from "../../../../components/recharts/ReMixCharts";
import { BrushStart, ChartType } from "../../../../models/chart_model";
import { renderHourTick } from "../../../../components/recharts/components";
import { ReactComponent as Upload } from "../../../../icons/upload-icon.svg";
import UpdateMergeDataModal from "../Resource/Popup/uploadMergeData";
import { ReactComponent as Undo } from "../../../../icons/undo.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchModDamDefault,
  fetchModGDamDefault,
  fetchModRtmDefault,
  fetchModDemandDefault,
  // ModDamData,
  // ModGDamData,
  // ModRtmData,
  // ModDemandData,
} from "../../../../Rest_api/RestApi";
import { ModLoadDataUpdate } from "../../../../store/state/ModLoadState";
import { normalizeDisplayLabelWithoutUndefined } from "../../../../utility/displayText";

const chartSuffixes = [
  {
    suffix: "demandPrice",
    displayName: "Target Day Demand",
    stackSuffix: "demandPrice",
    chartType: ChartType.Line,
    stroke: "rgba(150, 114, 22, 1)",
    unit: "MW",
    yAxisId: "left",
  },
  {
    suffix: "damPrice",
    displayName: "Anticipated DAM Rate",
    stackSuffix: "damPrice",
    chartType: ChartType.Line,
    stroke: "rgba(48, 110, 165, 1)",
    unit: "Rs/MWh",
    yAxisId: "right",
  },
  {
    suffix: "gdamPrice",
    displayName: "Anticipated GDAM Rate",
    stackSuffix: "gdamPrice",
    chartType: ChartType.Line,
    stroke: "rgba(26, 106, 77, 1)",
    unit: "Rs/MWh",
    yAxisId: "right",
  },
  {
    suffix: "rtmPrice",
    displayName: "Anticipated RTM Rate",
    stackSuffix: "rtmPrice",
    chartType: ChartType.Line,
    stroke: "rgba(192, 65, 129, 1)",
    unit: "Rs/MWh",
    yAxisId: "right",
  },
  {
    suffix: "previousDemandPrice",
    displayName: " Previous Day Demand",
    stackSuffix: "previousDemandPrice",
    chartType: ChartType.Line,
    stroke: "rgba(251, 191, 36, 1)",
    unit: "MW",
    yAxisId: "left",
  },
  {
    suffix: "previousDamPrice",
    displayName: "Previous Day DAM Rate",
    stackSuffix: "previousDamPrice",
    chartType: ChartType.Line,
    stroke: "rgba(96, 165, 250, 1)",
    unit: "Rs/MWh",
    yAxisId: "right",
  },
  {
    suffix: "previousGdamPrice",
    displayName: "Previous Day GDAM Rate",
    stackSuffix: "previousGdamPrice",
    chartType: ChartType.Line,
    stroke: "rgba(52, 211, 153, 1)",
    unit: "Rs/MWh",
    yAxisId: "right",
  },
  {
    suffix: "previousRtmPrice",
    displayName: "Previous Day RTM Rate",
    stackSuffix: "previousRtmPrice",
    chartType: ChartType.Line,
    stroke: "rgba(244, 114, 182, 1)",
    unit: "Rs/MWh",
    yAxisId: "right",
  },
];

const CombinedChartAnalysis = ({
  selectedBlock,
  dataDam,
  dataGDam,
  dataRtm,
  dataDemand,
  setDamData,
  setGDamData,
  setRtmData,
  setDemandData,
}: {
  selectedBlock: any[];
  dataDam: any[];
  dataGDam: any[];
  dataRtm: any[];
  dataDemand: any[];
  setDamData: React.Dispatch<React.SetStateAction<any[]>>;
  setGDamData: React.Dispatch<React.SetStateAction<any[]>>;
  setRtmData: React.Dispatch<React.SetStateAction<any[]>>;
  setDemandData: React.Dispatch<React.SetStateAction<any[]>>;
}) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [filterData, setFilterData] = useState<any[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedMetrics, setSelectedMetrics] = useState<any[]>([
    chartSuffixes[0],
    chartSuffixes[1],
    chartSuffixes[2],
    chartSuffixes[3],
    chartSuffixes[4],
    chartSuffixes[5],
    chartSuffixes[6],
    chartSuffixes[7],
  ]);
  const preSelectedDate = useSelector(
    (state: any) => state.modGridcoDate.selectedDate
  );
  const modSelectedSession = useSelector(
    (state: any) => state.modGridcoSession.modSession
  );
  const dispatch = useDispatch();
  // Reset button
  const handleReset = async () => {
    setLoading(true);
    try {
      // ---- 1. DAM ----
      const damRes = await fetchModDamDefault(preSelectedDate,modSelectedSession);
      const gdamRes = await fetchModGDamDefault(preSelectedDate,modSelectedSession);
      const rtmRes = await fetchModRtmDefault(preSelectedDate,modSelectedSession);
      const demandRes = await fetchModDemandDefault(preSelectedDate,modSelectedSession);
      if (damRes) {
        const damDate = damRes.date;

        // const damUploadData = {
        //   date: preSelectedDate,
        //   session: modSelectedSession,
        //   data: damRes.data,
        // };

        const damTransformed = damRes.data.map((item: any) => ({
          time_slot: item.time_slot,
          date: damDate,
          wt_mcp_rs_mwh: item.mcp_rs_mwh,
          previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,

        }));
        const damDispatchData = damRes.data?.map((item: any) => ({
          "Time Slot": item.time_slot,
          "Price (Rs/MWh)": item.mcp_rs_mwh,
        }));

        dispatch(ModLoadDataUpdate({ type: "dam", data: damDispatchData }));
        // await ModDamData(damUploadData);
        setDamData(damTransformed);
      }
      // ---- 2. GDAM ----

      if (gdamRes) {
        const gdamDate = gdamRes.date;

        // const gdamUploadData = {
        //   date: preSelectedDate,
        //   session: modSelectedSession,
        //   data: gdamRes.data,
        // };

        const gdamTransformed = gdamRes.data.map((item: any) => ({
          time_slot: item.time_slot,
          date: gdamDate,
          wt_mcp_rs_mwh: item.mcp_rs_mwh,
          previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,
        }));

        const gdamDispatchData = gdamRes.data?.map((item: any) => ({
          "Time Slot": item.time_slot,
          "Target": item.mcp_rs_mwh,
        }));

        dispatch(ModLoadDataUpdate({ type: "gdam", data: gdamDispatchData }));
        // await ModGDamData(gdamUploadData);
        setGDamData(gdamTransformed);
      }

      // ---- 3. RTM ----

      if (rtmRes) {
        const rtmDate = rtmRes.date;

        // const rtmUploadData = {
        //   date: preSelectedDate,
        //   session: modSelectedSession,
        //   data: rtmRes.data,
        // };

        const rtmTransformed = rtmRes.data.map((item: any) => ({
          time_slot: item.time_slot,
          date: rtmDate,
          wt_mcp_rs_mwh: item.mcp_rs_mwh,
          previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,
        }));

        const rtmDispatchData = rtmRes.data?.map((item: any) => ({
          "Time Slot": item.time_slot,
          "Price (Rs/MWh)": item.mcp_rs_mwh,
        }));

        dispatch(ModLoadDataUpdate({ type: "rtm", data: rtmDispatchData }));
        // await ModRtmData(rtmUploadData);
        setRtmData(rtmTransformed);
      }
      // ---- 4. Demand ----

      if (demandRes) {
        const demandDate = demandRes.date;

        // const demandUploadData = {
        //   date: preSelectedDate,
        //   session: modSelectedSession,
        //   data: demandRes.data,
        // };

        const demandTransformed = demandRes.data.map((item: any) => ({
          time_slot: item.time_slot,
          date: demandDate,
          wt_mcp_rs_mwh: item.mcp_rs_mwh,
          previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,
        }));

        const demandDispatchData = demandRes.data?.map((item: any) => ({
            Date: demandDate,
            Demand: item.demand_mw,
        }));
        dispatch(ModLoadDataUpdate({ type: "demand", data: demandDispatchData }));
        // await ModDemandData(demandUploadData);
        setDemandData(demandTransformed);
      }
    } catch (err) {
      console.error("Reset failed:", err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const reference =
      dataDam.length > 0
        ? dataDam
        : dataRtm.length > 0
        ? dataRtm
        : dataGDam.length > 0
        ? dataGDam
        : dataDemand;

    let merged = reference.map((item, idx) => ({
      time_slot: item.time_slot,
      date: preSelectedDate, // always comes from reference

      damPrice: dataDam[idx]?.wt_mcp_rs_mwh ?? null,
      previousDamPrice: dataDam[idx]?.previous_mcp_rs_mwh ?? null,

      gdamPrice: dataGDam[idx]?.wt_mcp_rs_mwh ?? null,
      previousGdamPrice: dataGDam[idx]?.previous_mcp_rs_mwh ?? null,

      rtmPrice: dataRtm[idx]?.wt_mcp_rs_mwh ?? null,
      previousRtmPrice: dataRtm[idx]?.previous_mcp_rs_mwh ?? null,

      demandPrice: dataDemand[idx]?.target_day ?? null,
      previousDemandPrice: dataDemand[idx]?.previous_target_day ?? null,
    }));
    if (selectedBlock.length > 0) {
      merged = merged.filter((item) =>
        selectedBlock
          .map((item) => Number(item.value))
          .includes(Number(item.time_slot))
      );
    }
    setFilterData(merged);
    const par: ChartDataParams = {
      keys: ["time_slot", "date", "month"],
      tableKeys: ["date", "time_slot", "month"],
      groupBy: [""],
      volumeKey: ``,
      aggregationKeys: [
        "damPrice",
        "previousDamPrice",
        "gdamPrice",
        "previousGdamPrice",
        "rtmPrice",
        "previousRtmPrice",
        "demandPrice",
        "previousDemandPrice",
      ],
      priceKey: "",
      data: merged,
    };

    const cData = FormatChartData(par);
    setChartData(cData.data);
    setChartKeys(cData.keys);
  }, [
    dataDam,
    dataDemand,
    dataGDam,
    dataRtm,
    preSelectedDate,
    selectedBlock,
    selectedMetrics,
  ]);

  const createChartObject = (
    key: string,
    index: number,
    suffix: string,
    displayName: string,
    stackSuffix: string,
    chartType: string,
    stroke: string,
    unit: string,
    yAxisId: string
  ) => {
    return {
      dataKey: `${key}_${suffix}`,
      name: `${normalizeDisplayLabelWithoutUndefined(key)} ${displayName}`,
      legendColor: undefined,
      type: chartType,
      stroke: stroke,
      unit: unit,
      yAxisId: yAxisId,
      stackId: stackSuffix !== undefined ? stackSuffix : undefined,
    };
  };

  function getLegends() {
    return selectedMetrics.flatMap(
      ({
        suffix,
        displayName,
        stackSuffix,
        chartType,
        stroke,
        unit,
        yAxisId,
      }) =>
        chartKeys.map(
          (key, index) =>
            createChartObject(
              key,
              index,
              suffix,
              displayName,
              stackSuffix,
              chartType,
              stroke,
              unit,
              yAxisId
            ) as any
        )
    );
  }

  return (
    <>
      <div className="load-data grid grid-cols-0 md:grid-cols-0 grid-rows-full md:grid-rows-1 gap-4 h-full w-full md:overflow-hidden !shadow-[rgba(149,157,165,0.2)_0px_8px_24px]">
        <div className="dash-card col-span-1 md:col-span-6 border border-[#718EBF1C] !bg-[#fff] !min-h-full w-full">
          <div className="flex justify-between items-center mb-4">
            <button
              onClick={handleReset}
              className="flex items-center gap-1 text-sm  text-[#6F6D7C] font-medium"
            >
              <Undo className="w-4 h-4" />
              Reset
            </button>
            <div className="">
              <h2 className="chartHeading !text-[#34656D] !font-medium">
                Aggregated Demand Price Analysis
              </h2>
            </div>
            <UploadBtn
              data={filterData}
              setDamData={setDamData}
              setGDamData={setGDamData}
              setRtmData={setRtmData}
              setDemandData={setDemandData}
              setMergedData={setFilterData}
              modalTitle="Upload Aggregated Data"
              title="Aggregated Demand Price Analysis"
            />
          </div>

          <>
            {loading ? (
              <div className="h-full w-full bg-white relative">
                <img
                  src={loader}
                  width={200}
                  alt="loader"
                  className="absolute inset-0 m-auto"
                />
              </div>
            ) : (
              <>
                {" "}
                {filterData.length === 0 ? (
                  <>
                    <div className="flex justify-center items-center h-full">
                      <p className="text-gray-500 text-[14px]">
                        Kindly click the Upload button to upload data.
                      </p>
                    </div>
                  </>
                ) : (
                  <ReMixChart
                    // maxYsize={10000}
                    // yMaxValue={10000}
                    chartHeight="calc(100% - 50px)"
                    data={chartData}
                    showBrush={true}
                    brushStart={BrushStart.Start}
                    isTimeSlot={true}
                    onlyTitle={true}
                    legends={getLegends()}
                    yAxisLabel="MW"
                    secondYAxisLabel="Rs/MWh"
                    nameGap={40}
                    xDataKey={"time_slot"}
                    top={10} // Top margin for grid
                    bottom={30} // Bottom margin for grid
                    xTick={(value: any, index: any) => {
                      return renderHourTick(value, 10);
                    }}
                    secondXDataKey={"date"}
                    showToolbox={false}
                  />
                )}
              </>
            )}
          </>
        </div>
      </div>
    </>
  );
};

export default CombinedChartAnalysis;

export function UploadBtn({
  data,
  setDamData,
  setGDamData,
  setRtmData,
  setDemandData,
  setMergedData,
  modalTitle,
  title,
  preSelectedDate,
}: {
  data: any[];
  setDamData: React.Dispatch<React.SetStateAction<any[]>>;
  setGDamData: React.Dispatch<React.SetStateAction<any[]>>;
  setRtmData: React.Dispatch<React.SetStateAction<any[]>>;
  setDemandData: React.Dispatch<React.SetStateAction<any[]>>;
  setMergedData: React.Dispatch<React.SetStateAction<any[]>>;
  modalTitle?: string;
  title: string;
  preSelectedDate?: string;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="upload_btn">
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="flex items-center gap-2 text-sm  text-[#6F6D7C] font-medium"
      >
        Upload
        <Upload className="w-5 h-5" />
      </button>
      <UpdateMergeDataModal
        data={data}
        setDamData={setDamData}
        setGDamData={setGDamData}
        setRtmData={setRtmData}
        setDemandData={setDemandData}
        setMergedData={setMergedData}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        modalTitle={modalTitle || "Upload template"}
        preSelectedDate={preSelectedDate}
      />
    </div>
  );
}
